import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild, ViewEncapsulation, TemplateRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

import { Job } from '../../../shared/models/job.model';

import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { ComboBoxComponent } from '@syncfusion/ej2-angular-dropdowns';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map} from 'rxjs';
import {Brand} from './../../../shared/models/brand.model';

// sycfusion dialog 
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { NgForm } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import { DataUtil } from '@syncfusion/ej2-data';
import { DomSanitizer } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import { FilterSettingsModel, GridComponent, GroupSettingsModel, IFilter, IFilterUI, PageSettingsModel, RowDataBoundEventArgs, SearchSettingsModel, SelectionSettingsModel, ToolbarItems, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

// e
@Component({
  selector: 'app-create-job',
  templateUrl: './create-job.component.html',
  styleUrls: ['./create-job.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService]
})
export class CreateJobComponent implements OnDestroy, OnInit, OnChanges  {


  currentURL: string;
  client_brands: any;
  sessionBrandId: any;
  sessionUsername: any;
  sessionUserId: any;
  currentUserVAR: any;
  // a declared property
trace_types: any;
brandsMysql: any;

public nav: any;
public model;
public today = Date.now();
public fee;
public trace;
public latest_trace_id;
public get_latest_trace_id;
public trace_id;
public trace_number_latest;
public get_trace_number_latest;
      // CURRENTS
      message: string; // from data CurrentsDataSourceComponent
      CTrace_id: string;
      CTrace_number: string;
      COwner_trace_code: string;
      CBrand_id: string;
      CReport_type_id: string;
      CClient_client_id: string;
      CStatus: string;
      CTrace_api_key: string;
      CClient_company_name: string;

      powers = ['Really Smart', 'Super Flexible',
            'Super Hot', 'Weather Changer'];

  // Passed variables from the Parent Controller - trace-create-step-2
  @Input() BrandClientContactManagerComponentMessage: string;
  @Input() BrandClientContactManagerComponentTraceID: string;

  // Set default trace_candidate_id
 // initialCount = 10; // Put this in the master
  // @Input() count = 0; // Put this in the child


  @Input() initialCount = 221;
  @Input() count = this.initialCount;

     // access the template form
    //  @ViewChild('jobForm', null) jobForm: NgForm;
     @ViewChild('jobForm') jobForm: NgForm;
    //  @ViewChild('jobForm') jobForm: any; // USE THIS METHOD

myCount = 10;
  job_types: any;
  job_type_locations: any;
  count2: any;
  sent_job_type_location_id: any;
  job_type_courts: any;
  sent_job_type_court_id: any;
  job_type_document_types: any;
  sent_job_type_document_type_id: any;
  job_type_affidavit_types: any;

// Set the passed ID
// set by passed initial Count.
client_brand_id = this.count;



// sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();

@Output()
change2: EventEmitter<number> = new EventEmitter<number>();

getBrandClientContacts: EventEmitter<String> = new EventEmitter<String>();

  clients: any;
  client_contacts: any;
  sent_client_id: any;
  get_latest_job_id: any;
  latest_job_id: any;
  brands: any;
  brand_users: any;
  sent_brand_id: any;
  brand_report_selected: any;
  new_special_instuctions: any;
  selected_brand_data: any;
  report_type_id: any;
  combo_model: Brand;

//:: combo box
// @ViewChild('sample')
@ViewChild('brand_invoice')
public comboBoxObj: ComboBoxComponent;

@ViewChild('brand_report_user')
// create object for state comboBox
public brand_report_userObj: ComboBoxComponent;

// maps the appropriate column to fields property
// public fields: Object = { text: 'Game', value: 'Id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' };
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  brands_client: any;
  brands_agent: any;
  baseUploadURL: string;
  DialogObj: any;
  job_service_rule: any;
  selected_job_service_rule_description: string;
  job_service_timeframe: any;
  selected_job_service_timeframe_description: string;
  job_service_rules: any;
  job_service_timeframes: any;
  subject_service_types: any;
  subject_service_type: any;
  selected_subject_service_type_description: string;
  selected_subject_service_type_instructions: string;
  selected_subject_service_type_staff_instructions: string;
  SubjectForm: any;
  job_type_document_type: any;
  modalRef: any;
  all_router_details: string;
  user_created_id: any;
  brand_users_data: any;
//::: combo box
showPrevVersion_Field: any;
  job_ref_check_data: Object;
  term_core: any;
  term_tokens: any;
  regexp_pattern: any;
  checking_ref: number;
  timeframe_surcharges: any;





  
countChange(event) {
 //  this.trace_candidate_id = event;
  console.log('clientbrandid: ' + this.client_brand_id);
}



  // Text editor Settings
  public simpleToolBar: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo',
    // {
    //   tooltipText: 'Insert Promotion',
    //   undo: true,
    //   click: this.onClickPromotionButton.bind(this),
    //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    // }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };
    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  }; 



  public pageSettings: Object;
  public pageOptions = { pageSize: 25 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: PageSettingsModel;
public selectionOptions: SelectionSettingsModel;
  dateFormat: string;
  public searchOptions: SearchSettingsModel;

    // maps the appropriate column to fields property
    public fields: Object = { text: 'NameAndAddress', value: 'brand_id' };
    //bind the Query instance to query property
    // public query: Query = new Query().from('Employees').select(['FirstName', 'City','EmployeeID']).take(6);
    //set the placeholder to ComboBox input
    public text: string = "Select an Company";
    //sort the result items
    public sorting: string = 'Ascending';


  constructor(private http: HttpClient, private _demoService: DemoService,
     private route: ActivatedRoute, public toastr: HotToastService,
      vcr: ViewContainerRef, private router: Router,
      private modalService: BsModalService, viewRef: ViewContainerRef, public gfunc: GlobalFunctionsService,
      private sanitizer: DomSanitizer,
      private clipboard: Clipboard, // ciipboard
      ) {


    this.nav = document.querySelector('nav.navbar');
    

  // login vars
  // this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
  // console.log('sessionUserId: ', this.currentUserVAR.user_id );
  // console.log('sessionUsername: ', this.currentUserVAR.username );
  // // Set loggind in User Value (USER ID)
  // this.sessionUserId = this.currentUserVAR.user_id;
  // this.sessionUsername = this.currentUserVAR.username;
  // this.sessionBrandId = this.currentUserVAR.brand_id;

    // Loads local items from JSON
  // this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(6));
     
  
  
  // Set and Access login Session Variables
       this.gfunc.setLoginSessionVars(); // set in a global function file
       this.sessionUserId = this.gfunc.currentUserVAR.user_id;
       this.sessionUsername = this.gfunc.currentUserVAR.username;
       this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
      
        // need to add this as routes does not work globally
        this.all_router_details = this.router.url;
        this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  this.getCLIENTClientBrands(this.sessionBrandId);



  
  this.toolbarOptions = ['ExcelExport', 'Search', { text: ' >: Filter Agents For Update Request',
    tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Click'  }
 ];
  // this.toolbar = [
  // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

 this.initialPage = { pageSize:10 };
 // FilterBar, Menu, Excel Checkbox
  this.filterOptions = {
     type: 'Menu'
  };

 // FilterBar, Menu, Excel Checkbox
 this.filterOptions_2022 = {
   type: 'Menu'
};
 this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
 // this.formatoptions = {};
 //  this.dateFormat = '';
  this.filter = {  };

 // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
 //  this.formatoptions = {type:'date', format:'dd/MM/yyyy'};
  this.dateFormat = 'dd/MM/yyyy hh:mm a';
  this.filter = { params: { format: this.dateFormat } };

  this.selectionOptions = {type: 'Multiple', checkboxOnly: true,}; // type: 'Multiple', mode: 'Both // checkboxMode: 'ResetOnRowClick'




   }


// New On Changes
ngOnChanges() {
  this.change.emit(this.initialCount);
  this.model = new Job();
  // this.model = new BrandClientContact();
  this.getBrandClientContacts.emit();
 

 // this.change2.emit(this.count2); // not required


}



  ngOnInit() {

    this.model = new Job();



    this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets; // no trailing
// Combo Box Options
this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
    this.getBrandsComboBoxClients(this.combo_model);
    this.getBrandsComboBoxAgents(this.combo_model);

    this.nav.className += ' white-bg';
this.report_type_id = this.count2;
   // this.getBrandsAll();




  // https://angular.io/guide/forms
  // TODO: Remove this when we're done
  // 1: Build a class to hold the constructor... ng g class <name of class>
  // 1: Class Content (app/shared/models) - place all class files here for ATS system
  /* eg export class Hero {
    constructor(
      public id: number,
      public name: string,
      public power: string,
      public alterEgo?: string
    ) {  }
  }
  */
  // 1. end eg.
  // 2. Inport the class/constructor into the component <>
  // 2. eg code :: import { Hero } from '../hero';  or depending on name and directory structire entire appropriate
  // 2. eg code :: import { Trace } from '../../../shared/models/trace.model';
  // 3. Add the Coponent code in the contructor area
  // 4. Wire up the form
  this.getTraceTypes(); // load the brands
  this.model = new Job(); // loads the Trace model into the model vars for the form.
  new DatePipeComponent(); // prints out today | ect and formats time as a function

  this.getJobTypes(); // load the brands
  this.getJobTypeLocations(0); // loads default locations as nothing
  this.getClients();
  this.getBrands();

  this.getJobServiceRules();
  this.getJobServiceTimeframes();
  
  this.getTimeframeSurcharges();

  // get the default Trace Number Value / Latest Inserted and increment by one.
  // this.getTraceNumberLatest();
  // this.getTraceNumberLatest(); // moved to create function script


  // set the creation date and user ID (and a collection of vars)
  // this.model.trace_id = "NULL"
  // this.model.trace_number = this.trace_number_latest; // needs to be set to the same system as exec.... TO DO




  this.model.created_date = this.today;
  this.model.created_by = this.sessionUserId;
  this.model.updated_date = this.today;
  this.model.updated_by = this.sessionUserId;
  this.model.brand_id = this.sessionBrandId;

  // Other Advanced Fields of the Trace

  this.model.project_type = 'TRACE';
  // System Default[TRACE] in all database records for ATS. another maybe EXEC REPORTING
  this.model.allocated_date = '';
  this.model.allocated_to = '';
  this.model.allocated_by = '';
  this.model.status = '23'; // DRAFT
  this.model.progress_percentage = '0';
  this.model.locate_status = ''; // not yet implimented TO DO!!
  this.model.total_candidates_count = ''; // not yet implimented TO DO!
  this.model.completed_candidates_count = '0';
  this.model.completed_date = '';
  this.model.trace_api_key = ''; // not yet implimented but can be used to key each trace to a user.
  this.model.special_instructions_HTML = '';

// update all job types not process serving. june 2025 update now fields are manditory. -- just set as not applicable by default.
this.model.job_service_rule_id = 0;
this.model.job_service_timeframe_id = 0;

    // this.model.timeframe_surcharge_id = 1; // set the default

  // console.log(this.model);
  this.currentURL = this.router.url;
  console.log ('routerURL:', this.router.url);

  }


  public ngOnDestroy(): any {
    this.nav.classList.remove('white-bg');
  }











// syncfusion dialog simple sample
public onOpenDialog = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'New CLient or a Login User',
    content: 'Create New - Not Currently Activated Yet!.',
    okButton: {  text: 'Ok', click: this.okClick.bind(this) },
    cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
private okClick(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
}

private cancelClick(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}




// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
//  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};





  // Data/BASE Functions





// BOF SHARMANS CALLS
getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypeLocations(job_type_id) {
  this._demoService.getJobTypeLocations(job_type_id).subscribe(
     data => { this.job_type_locations = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeLocationsID(job_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count2 = job_type_id;
  this.getJobTypeLocations(this.count2); // updates the selected job ID....
  // this.model.job_type_location_id = 1; // updated to include more locations
  this.model.job_type_court_id = 1;
  this.model.job_type_document_type_id = 0;
  this.model.job_type_affidavit_type_id = 0;

 console.log('sending Count:' + this.count2);
}


getJobTypeCourts(job_type_location_id) {
  this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
     data => { this.job_type_courts = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeCourtsID(job_type_location_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_location_id = job_type_location_id;
  this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  this.model.job_type_court_id = 1;
  this.model.job_type_document_type_id = 0;
  this.model.job_type_affidavit_type_id = 0;


 console.log('sending Location:' + this.sent_job_type_location_id);
}


getJobTypeDocumentTypes(job_type_court_id) {
  this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
     data => { this.job_type_document_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeDocumentTypesID(job_type_court_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_court_id = job_type_court_id;
  this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  this.model.job_type_document_type_id = 1;
  this.model.job_type_affidavit_type_id = 0;

 console.log('sending Court Type:' + this.sent_job_type_court_id);
}


getJobTypeAffidavitTypes(job_type_document_type_id) {
  this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
     data => { this.job_type_affidavit_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 sendJobTypeAffidavitTypesID(job_type_document_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.sent_job_type_document_type_id = job_type_document_type_id;
  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  this.model.job_type_affidavit_type_id = 1;
 console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
}



getClients() {
  this._demoService.getClients().subscribe(
     data => { this.clients = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getBrands() {
  this._demoService.getBrands().subscribe(
     data => { this.brands = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getBrandsComboBoxClients(combo_model) {
   this.combo_model.brand_type_id = 2;
  this._demoService.getBrandsComboBox(combo_model).subscribe(
     data => { this.brands_client = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getBrandsComboBoxAgents(combo_model) {
  this.combo_model.brand_type_id = 3;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_agent = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}





 getClientContactsSharmans(client_id) {
  this._demoService.getClientContactsSharmans(client_id).subscribe(
     data => { this.client_contacts = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 sendClientID(client_id) {
 this.sent_client_id = client_id;
 this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....

 console.log('sending Client ID:' + this.sent_client_id);
}



getBrandUsers(brand_report_id, access_level) {
  this._demoService.getBrandUsersByLevel(brand_report_id, 9).subscribe(
     data => { this.brand_users = data; 
   let res = data[0];

  // this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + res.user_id; // no trailing
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 // drop down action
 sendBrandID(brand_report_id) {
// this.toastr.info('BrandIDSend: ' + brand_report_id)

 this.sent_brand_id = brand_report_id;

 // reset the form field first.
 this.model.brand_report_user_id = '';
 // this.brand_users = '';
     // empty the array incase there are no users to prevent prev selection
     this.brand_users = null;

 if(brand_report_id >= 1) {
// this.getBrandUsers(brand_report_id); // updates the selected brand_ ID....
this._demoService.getBrandUsersByLevel(brand_report_id, 9).subscribe(
  data => { this.brand_users = data;


    this.brand_users_data = data;


    let res = data[0];
 },
  err =>  console.error(err),
  // () => console.log('done loading Trace Types')
);





 // this.model.brand_report_id = brand_report_id;
// need to look up what brands notes are and send to jon notes.
 // console.log('sending Brand ID:' + this.sent_brand_id);
// lookup brand
// set this.model.special_instuctions.
this.getBrandById_instructions(this.sent_brand_id); // sets the model special instuctions in function
 }


}







createJobTesting(model) {
 // this.router.navigate(['/admin/jobs/create-job-2/' + model.client_id + '']);
  // set the defaults.
      // model.created_by = this.gfunc.sessionUserId;
      // model.updated_by = this.gfunc.sessionUserId;
      // model.created_date = this.gfunc.today;

  model.created_by = this.gfunc.sessionUserId;
  model.updated_by = this.gfunc.sessionUserId;
  model.status = 'PENDING';
  model.job_status_code = 'PENDING'; // Set to pending for a client submission.
  model.file_number = 1; // set to establish correct filing numbers. when creating a job. April 30 2023
  model.allocated_to = 0; // sept 24
  model.allocated_by = 0; // setp 24
  model.total_candidates_count = 0; // setp 24

  

  model.created_date = this.gfunc.todayDate; // Nov 23 Date Creation Corrections.




  this._demoService.createJob(model).subscribe(
     data => {   this.get_latest_job_id = data; // this is the retuned json upon creation.
     this.toastr.success('New Job Project Saving...' + this.get_latest_job_id + '');
     // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}
     this.latest_job_id = this.get_latest_job_id.last_insert_id;

      // Setup annd the Currents before we redirec the page
      // Needs to be a Function to update the ObserveOnOperator.
      // this.newCTrace_id(this.latest_trace_id);
      // or this.cdata.changeCTrace_id("999");

      // this.router.navigate(['/admin/jobs/create-job-2/' + this.latest_job_id + '']);


      model.job_id = this.latest_job_id;
      // insert log
      // this.gfunc.insertLog_CreateJob(model);
      this.gfunc.insertLog_CreateJob_Client_Started(model) // or stff

      this.gfunc.globalJobEditStep2(this.latest_job_id);

        return true;


     },
     error => {
     // console.log('Should be form Model' + model);
     // console.error('Error Creating a Trace Project!');
       this.toastr.error('Adding Job Failed :: Please try again!');
       console.log(error(error));
      return console.log(error);
     }
);





}















    // the sql magic

    private getBrandsAll() {
      this._demoService.getBrandsAll()
        .subscribe(
          res => this.brandsMysql = res,
          err => console.error(err.status)
        );
    }

  // update all function test
  newCurrents () {
    // this.cdata.changeCTrace_id("Works."); // need to set upon update.
  }
  // END OF CURRENTS FUNCTION


  getTraceTypes() {
    this._demoService.getTraceTypes().subscribe(
       data => { this.trace_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getBrandById_instructions(brand_id){
    this._demoService.getBrandById(brand_id)
    .subscribe(
      res => {this.brand_report_selected = res;
        this.selected_brand_data = res[0];
       this.new_special_instuctions = this.selected_brand_data.brand_notes;
       this.model.special_instructions = this.new_special_instuctions;
       this.model.special_instructions_HTML = this.new_special_instuctions;
       // console.log('instuctions: ' + this.new_special_instuctions);
     
      },
      err => console.error(err.status)
    );
   }




   // Redirect not passing the latest inserted ID... Check... with user_id
   createTrace(model) {

    // set the defaults.
    model.created_by = this.sessionUserId;
    model.updated_by = this.sessionUserId;

    this._demoService.createTrace(model).subscribe(
       data => {   this.get_latest_trace_id = data; // this is the retuned json upon creation.
       this.toastr.success('New Trace Project Added');
        // wrong code here but right idea
       // this.latest_trace_id = ajax('http://rest.nickbowen.com.au/api/trace/latest/93/2');

       // this.get_latest_trace_id = this.http.get('http://rest.nickbowen.com.au/api/trace/latest/93/2');

        console.log('Body Data = ' + this.get_latest_trace_id.last_insert_id);

        // If we want it json
        // this.latest_trace_id = JSON.stringify(this.get_latest_trace_id);
       // console.log( this.latest_trace_id   + ' : Actual Latest Trace ID');

       // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}
       this.latest_trace_id = this.get_latest_trace_id.last_insert_id;

  // need to create the trace_stats insert. (function);

  // 1) Get the trace_candidate counts


        // Setup annd the Currents before we redirec the page
        // Needs to be a Function to update the ObserveOnOperator.

        // or this.cdata.changeCTrace_id("999");

       // ## Have to set this before update!!!!! on submit function!
                // this.getTraceNumberLatest(); // quiery function
                // console.log(this.getTraceNumberLatest())
                //  this.cdata.changeCTrace_number(this.trace_number_latest);




       // this.cdata.changeCTrace_id(this.latest_trace_id);


  // Lets Creat the stats table. with MSQL php serverice to look up create the Stats framework from the new ID



       // update the list
         // re-directs to new router. so it works both manager and client views
         if (this.currentURL === '/manager/traces/trace-create' ) {
          this.router.navigate(['/manager/traces/trace/' + this.latest_trace_id + '']);
         }else {
          this.router.navigate(['/traceView/trace-create-step-2/' + this.latest_trace_id + '']);
         }

         // original
         // this.router.navigate(['/traceView/trace-create-step-2/' + this.latest_trace_id + '']);
          return true;


       },
       error => {
       // console.log('Should be form Model' + model);
       // console.error('Error Creating a Trace Project!');
         this.toastr.error('Adding Trace Failed :: Please try again!');
         console.log(error(error));
        return console.log(error);
       }
  );
  }

  // Data/BASE Functions
  getTraceNumberLatest() {
    this._demoService.getTraceNumberLatest().subscribe(
       data => { this.get_trace_number_latest = data;
        this.trace_number_latest = this.get_trace_number_latest.trace_number;
        console.log('Latest Trace#: ' + this.trace_number_latest);
        this.toastr.info('Latest Trace #: <strong>' +
        this.trace_number_latest + ' -- Need to place this after the insert and run on the Slime side of things');
        return true;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }




  // CLIENT

  getCLIENTClientBrands(brand_id) {
    this._demoService.getCLIENTClientBrands(brand_id).subscribe(
       data => { this.client_brands = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   sendBrandClientContactID(client_brand_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count = client_brand_id;
    this.initialCount = client_brand_id;
   console.log('sending Count:' + this.count);
  }




  getJobServiceRule(job_service_rule_id) {
    this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
       data => { this.job_service_rule = data; 
        let res = data[0];
        if (job_service_rule_id <= 0 ){
          this.selected_job_service_rule_description = 'Not Applicable';
        };
        this.selected_job_service_rule_description = res.job_service_rule_description;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobServiceTimeframe(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe = data; 
        let res = data[0];
        if (job_service_timeframe_id <= 0 ){
          this.selected_job_service_timeframe_description = 'Not Applicable';
        };
        this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getJobServiceRules() {
    this._demoService.getJobServiceRules().subscribe(
       data => { this.job_service_rules = data; },
       err => console.error(err),
        () => {
          console.log('done loading SR');
                      }
          );
   }


   getJobServiceTimeframes() {
    this._demoService.getJobServiceTimeframes().subscribe(
       data => { this.job_service_timeframes = data; },
       err => console.error(err),
        () => {
          console.log('done loading SR');
                      }
          );
   }


   getSubjectServiceTypes() {
    this._demoService.getSubjectServiceTypes().subscribe(
       data => { this.subject_service_types = data;  },
       err => console.error(err),
        () => {
          // console.log('done loading Subject Service Types')
         // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
         // let mappedJSON = JSON.parse(mapped);
         // console.log('Mapped JSON Array: ' + mappedJSON);
        }
          );
   }

   
  getSubjectServiceType(subject_service_type_id) {
    this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
       data => { 
        this.subject_service_type = data;
        let res = data[0];
        if ( subject_service_type_id <= 0 ){
          this.selected_subject_service_type_description = 'Please Set to default Individual Above';
          this.selected_subject_service_type_description = '';
          this.selected_subject_service_type_instructions = '';
          this.selected_subject_service_type_staff_instructions = '';

        } 
        this.selected_subject_service_type_description = res.subject_service_type_description;
        this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
        this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;

        // initiate the change of service rule if different or select from drop down.
        if (subject_service_type_id > 1) {
        this.setJobServiceRule(res.job_service_rule_id_change_to);
        this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
        }

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }




   setJobServiceRule(job_service_rule_id) {
    // sets the form value upon change of the subject_service_type
    this.SubjectForm.controls['job_service_rule_id'].setValue(job_service_rule_id);
    this.toastr.info('Service Rule modified due to Service Entity Type Change. Please Save Subject Changes.' + job_service_rule_id);
};

sendJobServiceRuleID(job_type_document_type_id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  // this.sent_job_service_rule_id = job_service_rule_id;

  this.sent_job_type_document_type_id = job_type_document_type_id;
//  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....



        //   IMPLIMENTATION of Service Timeframes & Service Rules associated with document selection
        // ::@ Try to set the service rule and service timeframes from document here.
        //    What is the current selected DocumentID - lookup the  timeframes, and service rule IDS
        //    Then set them into the model and save as new variables as part of the job.
        //     TODO:: need to impliment this on create a job and set for all subjects on a subject level with defaults.
        //  this.model.job_service_rule_id = 




// Now lookup the Serice rule and set the selection with the ids.
  this.getJobTypeDocumentType(this.sent_job_type_document_type_id);
// NOW need to repeat this action for the service timeframes.


 console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
}



getJobTypeDocumentType(job_type_document_type_id) {
  this._demoService.getJobTypeDocumentType(job_type_document_type_id).subscribe(
     data => { this.job_type_document_type = data;
    let res = data[0];
    // Set the new form variables After the selected drop down of documents activated this function;
    // note :: SUCCESS (This also updates the model object variables in the form)
    this.jobForm.controls['job_service_rule_id'].setValue( res.job_service_rule_id);
    this.jobForm.controls['job_service_timeframe_id'].setValue( res.job_service_timeframe_id);
 
// Display the Rule Definition in UI/Template
// Need to do a quick lookup to get the values to set below both Timeframes and Rule Definitions on the page

this.getJobServiceRule(res.job_service_rule_id);
this.getJobServiceTimeframe(res.job_service_timeframe_id);





    // this.model.job_service_rule_id = res.job_service_rule_id;
    //   console.log('New job_service_rule_id ' + this.model.job_service_rule_id);
  },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




 createUserPrimary(model){
   model.created_by = this.sessionUserId;
   model.brand_id = model.brand_report_id;
    this._demoService.createPrimaryUser(model).subscribe(
       data => { this.user_created_id = data; 
        model.last_insert_id = this.user_created_id;
        this.gfunc.insertLog_CreateUser(model);
        this.onOpenDialog2(model);
        this.modalRef.hide(0);
      //  this.getBrandUsers(model.brand_report_id, 9);
      
      },
       err => console.error(err),
        () => {
          console.log('done creating User');
                      }
          );
 }





// syncfusion dialog simple sample
public onOpenDialog2 = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Created Login User',
    content: 'Successfully Create a User and Data Saved. You may continue.',
    okButton: {  text: 'Ok', click: this.okClick2.bind(this) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '.', click: this.okClick2.bind(this) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick2(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
 //this.router.navigate(['/admin/brands/companies']);
 this.router.navigate(['/admin/jobs'], { skipLocationChange: true })
 .then(() => this.router.navigate(['/admin/jobs/create-job'])
 );

}; // end functiiom

private cancelClick2(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
   this.modalRef.hide(); // hide the modal?
}




    // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
    getHtml(html){
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
  
      // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
    // WORKS as I created my own function from this articel == pretty well convers
    transform2(value: any, args?: any): any {
      const doc = new DOMParser().parseFromString(value, 'text/html');
      return doc.documentElement.textContent;
    }
  
  
    copyToClipboard(id) {
      const content = document.getElementById(id).innerHTML; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      this.clipboard.copy(content);
      this,this.toastr.info(" Copied")
      // this.copyInGrid('btnTwo', id);
    }
    
    copyToClipboardPlainText(id) {
      const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      this.clipboard.copy(content);
      this,this.toastr.info(" Copied")
      // this.copyInGrid('btnTwo', id);
    }


    importPrevContentToHTML(id, content_sent, model) {
      if (confirm('Are you sure? Warning: This action will replace any content in the new "Editor" for this specific field.' + id)) {
      // model.id = id+'_HTML'
      // const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      // this.clipboard.copy(content);

      const content = content_sent; // copy all formatting.
      // this.attemptForm.controls['updated_by'].setValue(id+'_HTML');
      

      // this.attemptForm.controls['general_notes_HTML'].setValue(content);
      this.jobForm.controls[id+'_HTML'].setValue(content);
      this.model.special_instructions_HTML = content;


      this.toastr.info("Updated Version: " + id+'_HTML')
      // this.LoadSubjectserviceOutcomeTemplateParagraph(model)
      // this.copyInGrid('btnTwo', id);
      }
    }
    
    // shows pre version field by id // ngif statments hard coded on each old text box
    showPrevVersion(id) {
      this.showPrevVersion_Field = id;
    
    } 

    hidePrevVersion() {
      this.showPrevVersion_Field = '';
    
    } 



    // New create job function to do some magic and looup possible refernce number senariaois coinating matching reference numbers or similar.
    duplicateJobReferenceLookup(model){

      this.job_ref_check_data = [] // empty the arry
      this.term_core = ''; // get ron first object as all will retun it
        this.term_tokens = ''; 
        this.regexp_pattern = '';
 
if(model.owner_trace_code != '' && model.brand_report_id >= '1' ){

  this.checking_ref = 1;

      // this.toastr.info("Cross referencing for report duplicates... ")
      this._demoService.duplicateJobReferenceLookup(model).subscribe(
        data => { this.job_ref_check_data = data; 
         
          if(this.job_ref_check_data){
          this.term_core = this.job_ref_check_data[0]?.term_core; // get ron first object as all will retun it
        this.term_tokens = this.job_ref_check_data[0]?.term_tokens;
        this.regexp_pattern = this.job_ref_check_data[0]?.regexp_pattern;
          }
        
       },
        err => console.error(err),
         () => {
           console.log('done looking for duplicates');
           this.checking_ref = 0;
                       }
           );


          } // end if

    }



    // grid functions
     toolbarClick(args: ClickEventArgs): void {
      if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
          this.grid.excelExport();
      }
    }
    rowDataBound(args: RowDataBoundEventArgs) {
      const job_status = 'job_status';
      if (args.data[job_status] === 'CLOSED') {
          args.row.className = 'strikethrough';
      }
    }
    
      // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
      clickHandler(args: ClickEventArgs): void {
        if (args.item.id === 'Click') {
    
        //  this.grid.showSpinner();
    
        //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
       //  console.log(args.data.items);
       
    
    
        let pdfdata;
        const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
        for (let i = 0; i < query.queries.length; i++) {
          if (query.queries[i].fn === 'onPage') {
            query.queries.splice(i, 1);       // remove page query to get all records
            break;
          }
        }
                // const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
                //   pdfdata = e.result as object[];  // get all filtered records
                //   const exportProperties = {
                //     dataSource: pdfdata,
                //   };
                //   //console.log(pdfdata.results);
                  
                //  // this.search_results = pdfdata.records; // need this if a grouping is set.
                //   this.search_results = pdfdata;
                //   this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
                //   this.toastr.success( "Press Start To Process Que"); 
                //  // this.grid.pdfExport(exportProperties);
                // }).catch((e) => true);
        }
    
       //  this.grid.hideSpinner();
    
    }

    searchGridColNextDate(name) {
      // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
      // const searchText: string = name;
      // this.grid.search(searchText);
      
      // clear first
      this.grid.searchSettings.key = '';
      // now update the search uptions
      this.searchOptions = { fields: ['next_date'], operator: 'lessThan', key: name, ignoreCase: true,   };
      // now refresh the grid
      this.grid.refresh();
      }






getTimeframeSurcharges() {
  this._demoService.getTimeframeSurcharges().subscribe(
     data => { this.timeframe_surcharges = data;  },
     err => console.error(err),
      () => {
        // console.log('done loading Subject Service Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }





  // tslint:disable-next-line:eofline
  } // ends the component class



  // Allows formatting of dates etc...
  export class DatePipeComponent {
    today: number = Date.now();
    fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
  // tslint:disable-next-line:eofline
  }
